export enum ColumnDataType {
  ArrayOfNumbers = 'arrayOfNumbers',
  ArrayOfStrings = 'arrayOfStrings',
  Boolean = 'boolean',
  Enum = 'enum',
  Expression = 'expression',
  Html = 'html',
  Image = 'image',
  Json = 'json',
  KMLMap = 'kmlMap',
  Lookup = 'lookup',
  Number = 'number',
  Price = 'price',
  Range = 'range',
  StyleIcon = 'styleIcon',
  Text = 'text',
  TextLocalizable = 'textLocalizable',
  Url = 'url',
}
